import React from "react";
import "./Header.css";

function Banner(props) {
  return (
    <>
      <link rel="preload" as="image" href="/images/4a2a004a8e908f42dbbfad724178abbe44fec273.webp" />
      <div
        className="p-5 text-center bg-image"
        style={{
          backgroundImage: props.url,
          height: "100vh",
          backgroundPositionY: "center",
          backgroundPositionX: "center",
          backgroundSize: "cover",
          contentVisibility: "auto",
          containIntrinsicSize: "auto 100vh",
        }}
      >
        <div className="banner-overlay"></div>
        <div className="mask">
          <div className="banner-content">
            <h1 className="main-title">KEEP YOUR FACE</h1>
            <h1 className="main-title main-title-accent">GLOWING</h1>
            <div className="banner-divider"></div>
            <h4 className="banner-subtitle">קליניקה לשיקום וטיפוח העור</h4>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
